{
  "documentEditor": {
    "title": "Editor dokumentu",
    "loading": "Otváranie dokumentu…",
    "slowLoading": "Načítanie editora trvá dlhšie. Môžete počkať alebo dokument znovu otvoriť.",
    "unavailable": "Editor dokumentu je nedostupný. Skúste dokument znovu otvoriť.",
    "invalidSession": "Reláciu dokumentu sa nepodarilo overiť. Otvorte dokument znovu.",
    "invalidDocument": "Tento dokument sa nedá otvoriť v editore.",
    "authenticationRequired": "Vaše prihlásenie vypršalo. Prihláste sa znovu a otvorte dokument.",
    "forbidden": "Nemáte oprávnenie otvoriť dokument v tomto režime.",
    "notFound": "Záznam alebo jeho príloha už nie sú dostupné.",
    "conflict": "Dokument je zamknutý alebo sa zmenil jeho stav. Skúste to neskôr.",
    "disabled": "Úprava dokumentov nie je v tomto prostredí dostupná.",
    "saveFirst": "Pred otvorením tejto prílohy v editore uložte záznam.",
    "reopen": "Znovu otvoriť dokument",
    "expired": "Relácia vypršala. Ponechajte editor otvorený, aby ste mohli skontrolovať svoju prácu. Novým otvorením môžete stratiť neuložené zmeny.",
    "expiring": "Relácia vyprší o menej ako päť minút. Dokončite svoju prácu v editore.",
    "confirmTitle": "Opustiť editor dokumentu?",
    "confirmLeave": "Zmeny sa môžu ešte ukladať. Pred odchodom alebo novým otvorením skontrolujte stav uloženia v editore.",
    "actions": {
      "view": "Otvoriť v OnlyOffice",
      "edit": "Upraviť v OnlyOffice",
      "review": "Revidovať v OnlyOffice",
      "comment": "Komentovať v OnlyOffice"
    },
    "modes": {
      "view": "Zobrazenie",
      "edit": "Úprava",
      "review": "Revízia",
      "comment": "Komentovanie"
    }
  },
  "overview": {
    "activities": "Prehľad aktivít",
    "noDashboardData": "Nemáte žiadne údaje pre prehľad",
    "approvals": "Záznamy na schválenie",
    "text": "Prehľad vašej agendy k <strong>{{date}}</strong>",
    "welcome": "Dobrý deň, ",
    "agendaOverview": "Prehľad agendy",
    "record": "Záznam",
    "newRecords": "Nové záznamy",
    "unfilled": "Nevyplnené",
    "favoriteAgendas": "Obľúbené agendy"
  },
  "comments": {
    "writeComment": "Napísať komentár"
  },
  "modules": {
    "title": "Vaše moduly",
    "subTitle": "Označte hviezdičkou agendy, ktoré chcete mať na prehľade.",
    "subTitleMobile": "Otvorte modul a označte hviezdičkou agendy pre prehľad.",
    "showAll": "zobraziť všetko",
    "childModules": "Podriadené moduly",
    "totalRecords": "Celkom záznamov",
    "waitingForApproval": "Čaká na schválenie",
    "newest": "Najnovšie",
    "shareRecordTitle": "Zdieľanie záznamu"
  },
  "delete": {
    "success": "Záznam bol úspešne vymazaný",
    "successMultiple_few": "{{count}} záznamy úspešne vymazané",
    "successMultiple_other": "{{count}} záznamov úspešne vymazaných",
    "error": "Pri mazaní záznamu sa vyskytla chyba",
    "errorForbidden": "Nemáte oprávnenie na vymazanie tohto záznamu",
    "errorMultiple_zero": "Pri mazaní záznamov sa vyskytla chyba. Žiadny záznam z {{total}} vybraných nebol vymazaný",
    "errorMultiple_one": "Pri mazaní záznamov sa vyskytla chyba. Bol vymazaný {{count}} záznam z {{total}} vybraných",
    "errorMultiple_few": "Pri mazaní záznamov sa vyskytla chyba. Boli vymazané {{count}} záznamy z {{total}} vybraných",
    "errorMultiple_other": "Pri mazaní záznamov sa vyskytla chyba. Bolo vymazaných {{count}} záznamov z {{total}} vybraných",
    "dirtyTableCannotDelete": "Nemôžete mazať záznamy, keď je tabuľka upravovaná. Uložte alebo zrušte svoje zmeny a skúste to znova.",
    "selectEntriesToDelete": "Najprv vyberte záznamy, ktoré chcete vymazať"
  },
  "detail": {
    "titleNew": "Nový záznam",
    "titleEdit": "Úprava záznamu",
    "share": {
      "title": "Osoby na zdieľanie",
      "add": "Pridať",
      "sharedTitle": "Osoby, s ktorými je záznam zdieľaný",
      "backToShare": "Zpäť na zdieľanie",
      "showOverview": "Zobraziť prehľad",
      "shareDateTime": "Dátum a čas zdieľania"
    },
    "file": {
      "copyLink": "Kopírovať odkaz",
      "copyEditLink": "Kopírovať editačný odkaz",
      "attachmentsTitle": "Prílohy",
      "filesCount_one": "{{count}} súbor",
      "filesCount_few": "{{count}} súbory",
      "filesCount_other": "{{count}} súborov",
      "maxFilesReached": "Je možné nahrať maximálne {{max}} súborov",
      "onlySomeFilesUploaded": "Bolo nahraných iba {{uploaded}} z {{total}} vybraných súborov (maximum: {{max}})",
      "maxFilesPerUpload": "Naraz je možné nahrať maximálne {{maxFiles}} súborov.",
      "fileTooLarge": "Maximálna veľkosť súboru je {{max}} MB.",
      "uploadInProgress": "Prebieha nahrávanie. Počkajte na jeho dokončenie.",
      "loadFailed": "Nepodarilo sa načítať prílohy.",
      "uploadFailed": "Súbor '{{fileName}}' sa nepodarilo nahrať.",
      "retry": "Skúsiť znova",
      "preview": {
        "notSupported": "Náhľad nie je podporovaný",
        "failedToDisplay": "Nepodarilo sa zobraziť náhľad dokumentu.",
        "noData": "Súbor neobsahuje žiadne dáta.",
        "readError": "Chyba čítania súboru."
      }
    },
    "form": {
      "title": "Chcete zavřít formulář?",
      "text": "Vo formulári máte neuložené zmeny. Ak ho zavriete, o tieto údaje prídete. Chcete formulár naozaj zavrieť?",
      "noCreate": "V tejto agende nie je povolené vytváranie záznamov"
    },
    "modal": {
      "changeBehaviorTitle": "Záznam bol zmenený",
      "saveNestedList": "V položkovom prehľade je neuložený záznam",
      "notifyUserToSave": "Pre správnu funkčnosť formulára je vhodné znovu uložiť záznam",
      "notifyUnsavedValues": "Formulár obsahuje hodnoty, ktoré nebudú uložené.",
      "saveRequired": "Pre správnu funkčnosť formulára je potrebné znovu uložiť záznam. Záznam bude uložený"
    },
    "lock": {
      "lockedTitle": "Záznam je uzamknutý",
      "lockedMessage": "Tento záznam práve upravuje {{name}}. Zámok vyprší o {{expiresAt}}.",
      "viewRecord": "Zobraziť záznam",
      "expiredTitle": "Zámok úprav vypršal",
      "expiringTitle": "Zámok úprav čoskoro vyprší",
      "expiringMessage": "Zámok záznamu čoskoro vyprší. Chcete pokračovať v úpravách?",
      "expiringCountdown": "Zámok vyprší o {{countdown}}",
      "continueEditing": "Pokračovať v úpravách",
      "stopEditing": "Ukončiť úpravy",
      "expiredMessage": "Váš zámok úprav vypršal z dôvodu neaktivity. Neuložené zmeny sú stratené.",
      "ok": "OK",
      "activeIndicator": "Upravujete tento záznam",
      "conflictExpired": "Váš zámok úprav vypršal. Prosím, znova otvorte režim úprav.",
      "editingBanner": "{{name}} práve upravuje tento záznam."
    },
    "deleteModal": {
      "title": "Vymazať záznam",
      "titleMultiple": "Vymazať záznamy",
      "text": "Naozaj chcete tento záznam vymazať? Táto akcia je nevratná.",
      "textMultiple_few": "Naozaj chcete vymazať {{count}} vybrané záznamy? Táto akcia je nevratná.",
      "textMultiple_other": "Naozaj chcete vymazať {{count}} vybraných záznamov? Táto akcia je nevratná."
    }
  },
  "contacts": {
    "title": "Rozdeľovník",
    "table": {
      "export": "Exportovať",
      "print": "Tlačiť",
      "filters": "Filtre",
      "search": "Hľadať"
    },
    "toast": {
      "groupUpdated": "Skupina bola úspešne aktualizovaná",
      "groupShared": "Skupina bola úspešne zdieľaná",
      "groupCreated": "Skupina bola úspešne vytvorená",
      "groupDeleted": "Skupina bola úspešne zmazaná",
      "groupAccepted": "Skupina bola úspešne prijatá"
    },
    "groups": {
      "_": "Skupiny",
      "title": "Skupiny",
      "create": "Vytvoriť",
      "search": "Hľadať v skupine",
      "groupName": {
        "label": "Názov novej skupiny",
        "placeholder": "Zadajte názov skupiny"
      },
      "all": "Vše",
      "users": "Používatelia",
      "usersToShare": "Osoby na zdieľanie",
      "accept": "Prijať",
      "remove": "Odstrániť",
      "decline": "Odmietnuť",
      "deleteConfirmTitle": "Naozaj chcete odstrániť túto skupinu?",
      "deleteConfirmDescription": "Táto akcia je nezvratná."
    },
    "contacts": {
      "person": "Osoba",
      "email": "Email",
      "phoneNumber": "Telefónne číslo",
      "organization": "Spoločnosť / Pracovná pozícia"
    },
    "add": "Pridať",
    "update": "Upraviť",
    "share": "Zdieľať"
  },
  "chat": {
    "assistantTitle": "Flowio asistent",
    "newChat": "Nový chat",
    "assistantLabel": "Asistent:",
    "youLabel": "Vy:",
    "modeLabel": "Režim",
    "modeGuide": "Asistenta",
    "modeGuideDescription": "Pomôže vám so všeobecnými otázkami a navigáciou v administrácii",
    "modeJson": "Šablón",
    "modeJsonDescription": "Pomôže vám generovať JSON šablóny pre jednoduchšiu administráciu",
    "thinkingAnalyzingDocs": "Premýšľam nad vašou otázkou",
    "thinking": "Asistent premýšľa…",
    "inputPlaceholder": "Napíšte správu…",
    "sendTitle": "Odoslať",
    "sendingTitle": "Odosielam…",
    "maximizeTitle": "Maximalizovať",
    "restoreTitle": "Obnoviť veľkosť",
    "closeTitle": "Zavrieť",
    "aiDisclaimer": "AI asistent môže robiť chyby. Overte si prosím dôležité informácie.",
    "copyText": "Kopírovať text",
    "copied": "Skopírované!",
    "history": "História",
    "chatHistory": "História konverzácií",
    "messages": "správ",
    "deleteHistory": "Zmazať históriu",
    "assistantIdMissing": "Assistant ID pre mód \"{{mode}}\" je prázdne alebo nie je nakonfigurované",
    "connectionError": "Nepodarilo sa pripojiť k serveru."
  },
  "substitutes": {
    "validation": {
      "substitutionType": {
        "required": "Typ zastúpenia je povinný"
      },
      "substituteUser": {
        "required": "Zastupujúci používateľ je povinný"
      },
      "absentUser": {
        "required": "Zastupovaný používateľ je povinný"
      },
      "dateFrom": {
        "required": "Dátum začiatku je povinný",
        "future": "Dátum začiatku musí byť v budúcnosti"
      },
      "dateTo": {
        "required": "Dátum konca je povinný",
        "future": "Dátum konca musí byť v budúcnosti",
        "afterDateFrom": "Dátum konca musí byť po dátume začiatku",
        "mustBeNull": "Dátum konca musí byť prázdny pre trvalé zástupy"
      },
      "permanentSubstitution": {
        "onlyForSubstitution": "Trvalý zástup je dostupný len pre typ zastúpenia"
      },
      "roles": {
        "required": "Aspoň jedna rola musí byť vybraná"
      }
    }
  },
  "agendaList": {
    "noData": "Žiadne záznamy."
  },
  "notifications": {
    "action": {
      "title": "Nevybavené úlohy",
      "subTitle": "Prehľad úloh, ktoré vyžadujú vašu pozornosť.",
      "noData": "Všetky úlohy, ktoré vyžadovali vašu pozornosť, sú teraz úspešne vybavené!"
    },
    "info": {
      "title": "Neprečítané informácie",
      "subTitle": "Prehľad dôležitých informácií, ktoré vyžadujú vašu pozornosť.",
      "noData": "Všetky dôležité informácie, ktoré vyžadovali vašu pozornosť, sú teraz úspešne vybavené!"
    },
    "deleteAll": "Vymazať všetko",
    "deleteAllSuccess": "Všetky informatívne notifikácie boli vymazané.",
    "filter": {
      "active": "Zobrazené záznamy s notifikáciami",
      "clear": "Zrušiť filter notifikácií"
    },
    "table": {
      "agenda": "Agenda",
      "description": "Obsah",
      "module": "Modul",
      "name": "Názov úlohy"
    }
  }
}
